"use strict";

var LoggerInstance = require("js-logger").get("LogoutStore");

var AbstractStore = require("./AbstractStore");

var Constants = require("../designer/Constants");

var Dispatcher = require("../dispatcher/Dispatcher");

var state = {
	wizardLoginDisplayMessages: {},
};

var LogoutStore = class extends AbstractStore {
	constructor(dispatcher) {
		super();
		this.dispatchToken = dispatcher.register(action => {
			switch (action.actionType) {
				case Constants.LOGOUT_INITIALIZE:
					state.wizardLoginDisplayMessages = action.options.wizardLoginDisplayMessages;
					return true; // Don't emit change

				default:
					// no op
					LoggerInstance.debug(`Undefined action triggered in logout store. ${action.actionType}`);
					return true;
			}

			this.emitChange();
			return true;
		});
	}

	getState() {
		return state;
	}

	get(key) {
		return state[key];
	}
};

module.exports = new LogoutStore(Dispatcher);